import React, {Component} from 'react';

import Cabecera from './Cabecera';
import Pie from './Pie';

class LayoutSimple extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  setStateGlobal = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }

  render() {
    const {parentState, isStep3} = this.props;
    return (<React.Fragment>
      <Cabecera parentState={parentState} setParentStateSteps={this.setStateGlobal}/> {this.props.children}
      <Pie parentState={parentState} setParentStateSteps={this.setStateGlobal} isStep3={isStep3}/>

    </React.Fragment>);
  }
}

export default LayoutSimple;
